module.exports = __webpack_public_path__ + "static/media/times-inputs.752a23d3.svg";